<template>
  <div class="fixed right-[10] bottom-[15%] cursor-pointer z-[5001]">
    <div class="relative z-[2002]">
      <el-popover :close-delay="0" width="310" placement="left" trigger="hover" popper-class="popper-help">
        <div slot="reference" class="w-[40] h-[120] relative">
          <img class="w-[100%] h-[100%]" v-if="getAssetsFile('public/fkzx.png')" :src="getAssetsFile('public/fkzx.png')"
            alt="">
          <img v-if="getAssetsFile('public/kefu.png')" class="absolute left-[3] top-[3] right-[3] w-[34] h-[34]"
            :src="getAssetsFile('public/kefu.png')" alt="">
          <p class="absolute top-[38] left-[0] right-[0] text-center t-[14] t-[#FFFFFF]">反<br />馈<br />咨<br />询</p>
        </div>
        <div class="px-[6] py-[16]">
          <div class="px-[10] pb-[10] border-b-[1] border-[#EBEBEB] border-solid">
            <p class="t-[14] t-[#303133]">在线反馈</p>
            <p class="t-[12] t-[#606266]" v-if="contact.serviceTime1 && contact.serviceTime2">服务时间：工作日 {{
              `${contact.serviceTime1} 至 ${contact.serviceTime2}` }}</p>
          </div>
          <div class="px-[6] mt-[14]">
            <div class="flex items-center cursor-pointer" @click="openHelp(1)">
              <img class="h-[36] w-[36]" src="@/assets/img/public/wtjy.png" alt="">
              <div class="text-left ml-[6]">
                <p class="t-[14] t-[#303133]">问题建议</p>
                <p class="t-[12] t-[#606266]">问题留言，我们会尽快联系您</p>
              </div>
              <i class="block ml-[auto] icon t-[14]">&#xe646;</i>
            </div>
            <div class="flex items-center mt-[21] cursor-pointer" @click="openHelp(2)">
              <img class="h-[36] w-[36]" src="@/assets/img/public/zxbz.png" alt="">
              <div class="text-left ml-[6]">
                <p class="t-[14] t-[#303133]">咨询帮助</p>
                <p class="t-[12] t-[#606266]">业务自助咨询，快速解决您的问题</p>
              </div>
              <i class="block ml-[auto] icon t-[14]">&#xe646;</i>
            </div>
            <div class="mt-[21]">
              <div class="flex items-center mt-[21]">
                <img class="h-[36] w-[36]" src="@/assets/img/public/zxdh.png" alt="">
                <div class="text-left ml-[6]">
                  <p class="t-[14] t-[#303133]">联系客服</p>
                  <p class="t-[12] t-[theme]" v-if="contactForm.mobile">
                    {{ contactForm.mobile }}
                  </p>
                </div>
              </div>
              <div class="flex items-center mt-[21]">
                <img class="h-[36] w-[36]" src="@/assets/img/public/gddh.png" alt="">
                <div class="text-left ml-[6]">
                  <p class="t-[14] t-[#303133]">固定电话</p>
                  <p class="t-[12] t-[theme]" v-if="contactForm.telephone && contactForm.telephoneReservation">
                    {{ contactForm.telephone }} / {{ contactForm.telephoneReservation }}
                  </p>
                  <p class="t-[12] t-[theme]" v-else-if="contactForm.telephone">
                    {{ contactForm.telephone }}
                  </p>
                  <p class="t-[12] t-[theme]" v-else-if="contactForm.telephoneReservation">
                    {{ contactForm.telephoneReservation }}
                  </p>
                </div>
              </div>
              <div class="flex text-center pt-[10]">
                <div class="pr-[10]">
                  <p><img v-if="contactForm.officialQrCode" :src="contactForm.officialQrCode" class="w-[80] h-[80]"
                      alt="" /></p>
                  <p class="pt-[4] t-[12] t-[#192530]">公众号</p>
                </div>
                <div class="pr-[10]">
                  <p><img v-if="contactForm.wechatQrCode" :src="contactForm.wechatQrCode" class="w-[80] h-[80]"
                      alt="" /></p>
                  <p class="pt-[4] t-[12] t-[#192530]">客服微信</p>
                </div>
                <div>
                  <p><img v-if="contactForm.appletQrCode" :src="contactForm.appletQrCode" class="w-[80] h-[80]"
                      alt="" /></p>
                  <p class="pt-[4] t-[12] t-[#192530]">小程序</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-popover>

      <div class="absolute w-[1] h-[1] bottom-[0] right-[360]" v-if="showHelp">
        <div class="relative">
          <div v-if="helpType == 1" class="help-box  w-[365] bg-[#FFFFFF] absolute bottom-[0] left-[0] p-[20]">
            <div class="h-[22] flex justify-between items-center t-[#303133]">
              <span class="t-[16] ">问题建议</span>
              <i class="icon" @click="closeHelp">&#xe641;</i>
            </div>
            <!-- 反馈成功 -->
            <div class="w-[100%] text-center h-[528]" v-if="showSuccess">
              <img class="h-[180] w-[180] mt-[100]" :src="getCityAssetsFile('feedback-success.png')" alt="">
              <p class="t-[#192530] t-[14]">感谢您的反馈！</p>
            </div>
            <!-- 上传问题 -->
            <div class="w-[100%] text-center" v-else>
              <div
                class="bg-[themeBrightColor9] h-[26] w-[100%] mt-[8] rounded-[2] flex justify-start items-center px-[8]">
                <img height="16" width="16" src="@/assets/img/public/help-icon.png" alt="">
                <p class="t-[12] t-[themeBrightColor3] pl-[2]">诚挚感谢您的反馈，这对我们非常重要！</p>
              </div>
              <div class="help-type mt-[8]">
                <div class="relative h-[32] w-[100%] flex justify-around items-center">
                  <div v-for="item in allFeedbackType" :key="item.key" @click="changeServiceType(item.key)"
                    class="h-[32] border-b-[2] border-[theme] relative z-[100] leading-[32] t-[#303133] t-[12] cursor-pointer"
                    :class="{ '!t-[theme] border-solid': formData.serviceType == item.key }">
                    {{ item.value }}</div>
                  <!-- <div @click="changeServiceType(1)"
                    class="h-[32] border-b-[2] border-[theme] relative z-[100] leading-[32] t-[#303133] t-[12] cursor-pointer"
                    :class="{ '!t-[theme] border-solid': formData.serviceType == 1 }">
                    需求建议</div> -->
                  <div class="bg-[#E4E7ED] h-[2] w-[100%] absolute left-[0] bottom-[0]"></div>
                </div>
                <dg-alert-box></dg-alert-box>
                <div class="help-form mt-[16] h-[376] w-[330]">
                  <!-- <div class="h-[35]"> -->

                  <!-- </div> -->
                  <el-form :model="formData" ref="formData" label-suffix="：" size="small" :rules="rules"
                    label-width="94px" inline label-position="left" align="left">
                    <div class="form-content h-[342]">
                      <el-form-item label="标题" prop="title">
                        <el-input v-model="formData.title" placeholder="请输入标题" class="w-[230]"></el-input>
                      </el-form-item>
                      <el-form-item label="描述" prop="content">
                        <el-input type="textarea" clearable :autosize="{ minRows: 4 }" :rows="4" class="w-[230]"
                          size="mini" v-model="formData.content" placeholder="请输入需求场景、问题、期待效果"></el-input>
                      </el-form-item>
                      <el-form-item label="附件" prop="attachment">
                        <div class="w-[230] t-[12] t-[#909399] leading-[20] py-[4]">
                          支持pdf、jpg、jpeg、png、doc格式，每份大小不超过50M，最多上传6张</div>
                        <dg-upload-list :imgBtn="true" fileName="附件" :fileSize="50" v-model="formData.attachment"
                          @input="inputImg" objName="attachment" :index="6" @hanldeDel="hanldeDel">
                          <img height="80" width="80" src="@/assets/img/public/dg-upload1.png" alt="">
                        </dg-upload-list>

                      </el-form-item>
                      <el-form-item label="联系电话" prop="mobile">
                        <el-input v-if="showEdit" v-model="formData.mobile" placeholder="请输入联系电话"></el-input>
                        <p v-if="!showEdit">{{ formData.mobile }}<span class="t-[theme] ml-[4]"
                            @click="showEdit = true">编辑</span></p>
                      </el-form-item>
                    </div>
                    <el-button type="primary" class="w-[325]" size="small" @click="hanldeSubmit">提交</el-button>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="help-box h-[650] w-[365] bg-[#F0F2F5] absolute bottom-[0] left-[0]">
            <div class="leading-[46] flex justify-between items-center px-[20] bg-[#fff]">
              <span>咨询帮助-自助服务</span>
              <i class="icon" @click="closeHelp">&#xe641;</i>
            </div>
            <div class="container h-[584] px-[20] pb-[16] pt-[12] overflow-y-auto">
              <div class="text-center">
                <p class="t-[12] t-[#909399] leading-[18]">您好！{{ userName }}</p>
                <p class="t-[12] t-[#909399] leading-[18]">提供常见问题和便捷CA驱动，助您轻松使用平台</p>
              </div>

              <div class="mt-[16] flex justify-start">
                <p class="bg-[#fff] p-[12] rounded-[8] w-[fit-content]">您好，很高兴为您服务，您是否需要咨询以下几个问题？</p>
              </div>

              <div class="mt-[16] flex justify-start" v-show="helpList.length">
                <div class="bg-[#fff] p-[12] rounded-[8] w-[fit-content]">
                  <p class="t-[14] t-[#606266]">您可能要问：</p>
                  <p class="t-[theme] t-[14] mt-[8]" v-for="(item, index) in helpList" @click="selectSend(item)">
                    {{ `${index + 1}、${item.title}` }}</p>
                </div>
              </div>

              <template v-for="item in questionList">
                <div class="mt-[16] flex justify-start" v-if="item.type == 1">
                  <p v-if="item.content.contentType == 0"
                    class="bg-[#fff] p-[12] rounded-[8] w-[fit-content] t-[#303133] break-word max-w-[300]">
                    <span v-html="item.content.content"></span>
                  </p>
                  <p v-else class="bg-[#fff] p-[12] rounded-[8] w-[fit-content] t-[#303133] break-word max-w-[300]">
                    <span class="t-[#0048FF] underline hover:t-[#551A8B]" @click="wopen(item.content.content.url)">{{
                      item.content.content.word }}</span>
                  </p>
                </div>
                <div class="mt-[16] flex justify-end" v-else>
                  <p class="bg-[theme] p-[12] rounded-[8] w-[fit-content] t-[#fff] break-word max-w-[300]">{{
                    item.content.title }}</p>
                </div>
              </template>
            </div>

            <!-- <div class="h-[74] pb-[20] bg-[#F0F2F5] px-[20]">
              <div class="h-[54] search-div">
                <el-input v-model="content" class="h-[54]" @keyup.enter.native="handleSend">
                  <template #suffix>
                    <div class="h-[30] w-[30] bg-[theme] m-[12] rounded-[15] flex justify-center items-center"
                      :class="{ 'opacity': content == '' }" @click="handleSend">
                      <i class="icon t-[#fff]">&#xe627;</i>
                    </div>
                  </template>
                </el-input>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- <el-popover placement="bottom-end" width="250" trigger="hover" popper-class="popper-phone">
      <div slot="reference" class="item cursor-pointer"> -->

    <div v-show="showHelp" class="help-mask h-[100vh] w-[100vw] fixed left-[0] top-[0] cursor-pointer z-[2001]"></div>

  </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
  mixins: [mixin],
  name: "dg-help",
  props: {
    contact: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      showPop: true,//是否开始
      content: '',
      userName: "",
      helpList: [],
      questionList: [],
      showEdit: false,
      helpType: '',//咨询类型
      showHelp: false,//是否开始
      showSuccess: false,
      formData: {
        attachment: [],  // 附件 
        content: "",  // 内容描述 
        mobile: "",  // 手机号码 
        serviceType: 0,  // 服务类型 0:需求建议 1:产品缺陷 
        title: "",  // 标题名称 
      },
      rules: {
        content: [{ required: true, message: "请填写描述内容" }],
        mobile: [{ required: true, message: "请填写手机号码" }],
        title: [{ required: true, message: "请填写标题" }],
        attachment: [{ required: true, message: "请上传附件" }],
      },
      contactForm: {},
      allFeedbackType: [],
    };
  },
  watch: {
    contact: {
      handler(newVal) {
        if (newVal) {
          this.contactForm = newVal
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    pushQuestionList(content, type) {
      let obj = { content: content, type: type }
      this.questionList.push(obj)
      this.$nextTick(() => {
        let container = ""
        container = document.querySelector('.container');
        container.scrollTop = container.scrollHeight - container.clientHeight;
      })
    },
    // 选择问题
    selectSend(item) {
      this.pushQuestionList(item, 2)
      ajax.post({
        url: '/customer/consultationHelp/detail',
        data: { id: item.id },
        success: (res) => {
          setTimeout(() => {
            let data = JSON.parse(JSON.stringify(res))
            let content
            if (res.contentType == 1) {
              content = JSON.parse(res.content)
              data.content = content
            }
            this.pushQuestionList(data, 1)
          }, 1000)

        },
      })
    },
    handleSend() {
      if (this.content != '') {
        ajax.post({
          // headers:{'Content-Type': 'application/json'},
          url: '/customer/consultationHelp/list',
          data: {},
          success: (res) => {
            this.helpList = res
          },
        })
      }
    },
    getHelpList() {
      ajax.post({
        // headers:{'Content-Type': 'application/json'},
        url: '/customer/consultationHelp/list',
        data: {},
        success: (res) => {
          this.helpList = res
        },
      })
    },
    hanldeSubmit() {
      console.log(this.formData)
      this.$refs.formData.validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.formData));
          let arr = params.attachment.map((item) => {
            return item.value || item.path;
          });
          params.attachment = arr.join(",");
          ajax.post({
            // headers:{'Content-Type': 'application/json'},
            url: '/customer/workOrder/create',
            data: params,
            success: () => {
              // console.log(res, 'res')
              this.showSuccess = true
              this.showEdit = false
              this.$refs.formData.resetFields();
              this.formData.attachment = []
              this.getMobile()
            },
          })
        }
      })

    },
    hanldeDel(key, name) {
      this.formData[name].splice(key, 1)
    },
    inputImg(list, name) {
      this.formData[name] = list
      console.log(this.formData[name])
      this.$refs.formData.validateField(name, err => {
        if (err) {
          return;
        }
      });
    },
    openHelp(type) {
      Mirror.emit("dg_form_dialog_open");
      this.showSuccess = false
      this.helpType = type
      this.showHelp = true
      this.showEdit = false
      this.formData = {
        attachment: [],  // 附件 
        content: "",  // 内容描述 
        mobile: "",  // 手机号码 
        title: "",  // 标题名称 
        serviceType: this.formData.serviceType,
      }
      this.questionList = []
      this.getMobile()
      if (type == 2) {
        this.getHelpList()
      }
    },
    closeHelp() {
      Mirror.emit("dg_form_dialog_close");
      this.helpType = ''
      this.showHelp = false
      this.showSuccess = false
    },
    changeServiceType(type) {
      this.formData.serviceType = type
      this.showEdit = false
      this.$refs.formData.resetFields();
      this.formData.attachment = []
      this.getMobile()
    },
    getMobile() {
      let user = JSON.parse(localStorage.getItem('current') || '{}').user || {}
      this.formData.mobile = user.mobile || ''
      this.userName = user.realName || ''
    },
    getFeedBackType() {
      ajax.post({
        url: '/customer/common/allFeedbackType',
        data: {},
        self: this,
        success: (res) => {
          this.allFeedbackType = res
          this.formData.serviceType = res[0].key
        },
      })
    },
  },
  mounted() { },
  created() {
    this.getFeedBackType()
  },
};
</script>
<style scoped lang="less">
.opacity {
  opacity: 0.5;
}

.help {
  background: #FFFFFF;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.12);
  border-radius: 50%;
  border: 1px solid #E4E7ED;
}

.help-box {
  box-shadow: 0px 12px 48px 0px rgba(0, 0, 0, 0.03), 0px 9px 28px 0px rgba(0, 0, 0, 0.05), 0px 6px 16px 0px rgba(0, 0, 0, 0.08);
  border-radius: 4px 4px 4px 4px;
}

.help-mask {
  background-color: rgba(0, 0, 0, 0.3);
}

// .help-form {
//   // overflow-y: auto;
// }

.form-content {
  overflow-y: auto;
}

.help-form .el-form--inline .el-form-item {
  margin-right: 0 !important;
}

.help-form .el-form-item--small.el-form-item {
  margin-bottom: 16px !important;
}
</style>
<style lang="less">
.popper-help {
  padding: 8px 0 !important;
}

.search-div .el-input__inner {
  line-height: 54px;
  height: 54px;
  padding-right: 54px;
  border-radius: 8px;
}
</style>
